import React, { useState, useEffect } from "react";
import Card from "../components/Card";
import LazyLoad from "react-lazyload";
import Skeleton from "@material-ui/lab/Skeleton";
import { format } from "date-fns";

function AllLaunches() {
  const [array, setArray] = useState([]);
  const [loading, setLoading] = useState(true);

  async function getLaunches() {
    try {
      setLoading(true);
      let response = await fetch("https://api.spacexdata.com/v4/launches/past");
      let json = await response.json();
      setArray(json);
    } catch (error) {
      console.log(error);
    } finally {
      // timeout to simulate loading time to see the sceleton
      setTimeout(() => {
        setLoading(false);
      }, 3000);
    }
  }

  useEffect(() => {
    getLaunches();
  }, []);

  return (
    <>
      <div
        style={{
          display: "grid",
          // display: "flex",
          justifyContent: "center",
          // flexWrap: "wrap",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 450px)",
          // gridTemplateColumns: "1fr 1fr",
        }}
      >
        {array
          .map((launch, index) => (
            <LazyLoad
              once={launch.once}
              key={index}
              height={300}
              offset={[-100, 0]}
              // placeholder={<h3>loading mission..</h3>}
              // debounce={500}
            >
              {!loading ? (
                // conditional render for skeleton
                <Card
                  once={launch.once}
                  missionName={launch.name}
                  missionDate={format(
                    new Date(launch.date_local),
                    "dd.MM.yyyy"
                  )}
                  // missionDate={launch.date_local}
                  missionDetails={
                    launch?.details || "no details for that mission"
                  }
                  missionBadge={launch.links?.patch.small}
                  missionImage={
                    launch.links?.flickr?.original[1] ||
                    launch.links?.patch.small
                  }
                  loading={loading}
                />
              ) : (
                // Skeleton
                <div
                  style={{
                    border: "1px solid #ffffff1c",
                    padding: 10,
                    borderRadius: 5,
                    height: 400,
                  }}
                >
                  <Skeleton
                    animation="wave"
                    variant="circle"
                    width={50}
                    height={50}
                  />
                  <br />
                  <Skeleton
                    animation="wave"
                    variant="rect"
                    width={"100%"}
                    height={250}
                  />
                  <Skeleton
                    animation="wave"
                    variant="text"
                    width={"100%"}
                    height={18}
                  />
                  <Skeleton
                    animation="wave"
                    variant="text"
                    width={"100%"}
                    height={18}
                  />
                  <Skeleton
                    animation="wave"
                    variant="text"
                    width={"70%"}
                    height={18}
                  />
                </div>
              )}
            </LazyLoad>
          ))
          .reverse()}
      </div>
    </>
  );
}

export default AllLaunches;
